<template>
  <v-flex xs1 class="icon" :class="additionalClass">
    <slot></slot>
  </v-flex>
</template>

<script>
export default {
  name: 'user-icon',
  props: ['icon', 'additionalClass'],
};
</script>

<style scoped>
  .icon {
    max-width: 50px;
    min-width: 40px;
  }
</style>
